import { EmojiPickerV4Provider } from "./EmojiPickerV4Context";
import { EmojiPickerV4Popover } from "./Popover";
import type { EmojiPickerV4Props } from "./types";

export const EmojiPickerV4 = (props: EmojiPickerV4Props) => (
  <EmojiPickerV4Provider {...props}>
    <EmojiPickerV4Popover />
  </EmojiPickerV4Provider>
);
